import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import Navbar from './components/navbar.jsx'
import {Route,BrowserRouter,Routes,Navigate} from 'react-router-dom'
import FAQSection from './components/serviceClients.jsx'
import Apropos from './components/apropos.jsx'
import Contact from './components/contact.jsx'
import EmployeeServices from './components/employés.jsx'
import PartnerServices from './components/partenaire.jsx'
import Footer from './components/footer.jsx'
import { SnackbarProvider, useSnackbar } from 'notistack';
import Page from './components/page.jsx';
import { store } from './components/store.js'
import { Provider } from 'react-redux'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    
    <Provider store={store}>
    <BrowserRouter>
    <SnackbarProvider maxSnack={3}>
    <Navbar/>
      <Routes>
        <Route path='/' element={<App />}/>
        <Route path='/services' element={<FAQSection/>}/>
        <Route path='/about' element={<Apropos/>}/>
        <Route path='/employees' element={<EmployeeServices/>}/>
        <Route path='/partners' element={<PartnerServices/>}/>
        <Route path='/page/:id' element={<Page/>}/>


       
      </Routes>
      <Footer/>
      </SnackbarProvider>
      </BrowserRouter>
      </Provider>
  </StrictMode>,
)
